import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeReferralsResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeReferralsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeReferralsSchema>
type Response = DataResponseWithPagination<z.infer<typeof BackofficeReferralsResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getBackofficeReferralsQueryKey = (query?: Query) =>
  ["backofficeReferrals", query].filter((value) => value)

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeReferralsQuery = ({ query, onSuccess }: Props) =>
  queryOptions({
    queryKey: getBackofficeReferralsQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/referrals", { params: query })
      onSuccess?.(data)
      return data.data
    },
  })
